
const base = 'https://bus-test.lazhuyun.cn';
export default {
	env: API_CONFIG.ENV,// 渠道 0 测试 1正式 2本地 3演示
	base: API_CONFIG.ENV==2?base:location.origin,
	productBase: API_CONFIG.PRODUCT_BASE,//产品页域名
	h5Base: API_CONFIG.H5_BASE,//公众号域名
	apiBase: API_CONFIG.API_BASE,//公众号、产品页接口域名
	htmlUrl: location.origin,
	test: 'http://192.168.32.246:58180'
}
